<template>
  <div class="card-msg">
    <div class="card-body-text">
      <ComentarioIcon />

      <div class="button-commentary">
        <p class="text">{{ text }}</p>
        <div>
          <b-button
            class="button-commentary-button"
            variant="primary"
            @click="showModal = true"
            >Comentar</b-button
          >

          <b-modal v-model="showModal" hide-footer hide-header>
            <!-- <div class="d-block text-center"> -->
            <Modal :crearComentario="crearComentario" />
            <!-- </div> -->
          </b-modal>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ComentarioIcon from "../../components/icons/home/ComentarioIcon";
import Modal from "./Modal";
import axios from "axios";
import { showAlert } from "../../components/tools/utils";
export default {
  components: {
    ComentarioIcon,
    Modal,
  },
  computed: {
    ...mapGetters(["commentary"])
  },
  methods: {
    crearComentario: async function(comentario) {
      let toReturn;
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/comentarios/`,
          comentario, 
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        );
        toReturn = res.data;
        showAlert({
          icon: "success",
          text: "Comentario enviado correctamente",
          timerProgressBar: true,
          timer: 3000,
        });
        this.showModal = false;
      } catch (error) {
        showAlert({
          icon: "error",
          text: error.response ? error.response.data[Object.keys(error.response.data)[0]] : 'error',
          timerProgressBar: true,
          timer: 3000,
        });
      }

      return toReturn;
    }
  },
  watch: {
    commentary: function() {
      // console.log(this.commentary)
    }
  },
  data() {
    return {
      text:
        "Te invitamos a comentar sobre los datos que has revisado y su forma de despliegue.",
      showModal: false,
    };
  },
};
</script>

<style>
.col-msg {
  text-align: left;
}
p {
  margin: 0 !important;
}

.card-msg {
  width: 300px;
  height: 70px;
  background: #052333;
  margin-top: 15px;
  border-radius: 50px;
  display: flex;
}

.fa-comment-dots {
  color: #fff;
}

.bx-comment-dots-image {
  width: 40px;
}

.text {
  color: #fff;
  font-size: 10px;
  padding: 0.5rem;
}

.card-body {
  padding: 0 !important;
}

.card-body-text {
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 0 1rem;
  margin-top: -10px;
}

.button-commentary {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.btn {
  padding: 0.07rem 1rem;
}
.button-commentary-button {
  font-size: 10px !important;
  border-radius: 50px !important;
  padding: 0 0.5rem !important;
}
.modal-body {
  padding: 0 !important;
}

@media screen and (max-width: 500px) {
  .card-msg {
    display: none;
  }
}
</style>
